export default __webpack_public_path__ + "static/media/rocket.40329a34.gif";